'use strict';

/**
 * Collection for shop offers
 *
 * @category   Collection
 * @module     shop
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Collection = require('base/Colido.Collection');
var Offer = require('../models/offer');

var OffersCollection = Collection.extend({
    api: function() {
        var api = '/shops/offers';

        if (this.shop) {
            api =  this.shop.api + '/' + this.shop.id + '/offers';
        }

        return api;
    },

    getName: function() {
        var name = 'collections:shops:offers';

        if (this.shop) {
            name =  this.shop.collection.name + ':' + this.shop.id + ':offers';
        }

        return name;
    },

    name: 'collection:shops:offers',

    model: Offer,

    // sortDefault: 'created.desc',

    conversation: null,

    initialize: function(models, options) {
        options = options || {};

        if (!options.shop) {
            return Colido.config.debug && console.log('You have to provide a shop model as option when initializing an offers collection');
        }

        this.shop = options.shop;

        this.name = this.getName();

        // this.applyPatchExtension();

        this.listenTo(App.radio(this.name).vent, 'updated', function(data) {
            this.setFromWebsocket(data, {remove: false});
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'removed', function(data) {
            this.remove(data); //data [1,2,3]
        }.bind(this));

        this.listenTo(App.radio(this.name).vent, 'added', function(data) {
            this.add(data);
        }.bind(this));
    },

    /**
     * Override default comparator to order by id, when default comparison is equal
     * @param {Backbone.Model} a Model a
     * @param {Backbone.Model} b Model b
     * @returns {integer}
     */
    comparator: function(a, b) {
        var compare = Collection.prototype.comparator.call(this, a, b);

        if (compare === 0) {
            return parseInt(a.get('id')) < parseInt(b.get('id')) ? -1 : 1;
        } else {
            return compare;
        }
    },
});

module.exports = OffersCollection;